import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { FieldProps } from 'formik';
import { OnChangeValue } from 'react-select';
import ProductSelect, { ProductOption, Props } from './ProductSelect';
import { pickProductIsAvailable, pickProductName, pickProductPrice } from 'api/GraphQL/util';

/** Only single select */
const ProductSelectField = ({
  field,
  form: { setFieldValue },
  ...props
}: Omit<Props<false>, 'isMulti'> & FieldProps) => {
  const onChange = (option: OnChangeValue<ProductOption, false>) => {
    setFieldValue(
      field.name,
      props.products?.find((i) => i.id === option?.value),
    );
  };

  const getValue = () => {
    if (!field.value) {
      return null;
    }
    const {
      id,
      externalReference,
      videos,
    } = field.value;

    return {
      value: id,
      label: pickProductName(field.value)!,// getProductTitleByLanguage(productLocalisations, language),
      price: pickProductPrice(field.value),// getProductPriceByLanguage(productLocalisations, language),
      isAvailable: pickProductIsAvailable(field.value),// isAvailable || false,
      subtitle: externalReference,
      //TODO: Add video count/videos form handling
      numberOfVideos: videos?.length,
    };
  };
  return (
    <ErrorBoundary>
      <ProductSelect
        {...field}
        {...props}
        value={getValue()}
        onChange={onChange}
      />
    </ErrorBoundary>
  );
};

export default ProductSelectField;
